import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { SuperAdminAuthService } from '../services/superadmin-auth.service';
import { NotificationService } from '../services/notification.service';

/**
 * Allows access when authenticated via super-admin OTP or legacy admin auth.
 */
export const platformAuthGuard: CanActivateFn = (route, state) => {
  const superAdminAuthService = inject(SuperAdminAuthService);
  const authService = inject(AuthService);
  const router = inject(Router);
  const notificationService = inject(NotificationService);

  if (superAdminAuthService.isAuthenticated()) {
    const user = superAdminAuthService.getCurrentUser();
    if (superAdminAuthService.hasSuperAdminRole(user)) {
      return true;
    }
  }

  if (authService.isAuthenticated() && authService.isAdmin()) {
    const requiredPermission = route.data['permission'];
    if (requiredPermission && !authService.hasPermission(requiredPermission)) {
      notificationService.error('Access denied. Insufficient permissions.');
      router.navigate(['/super-admin/dashboard']);
      return false;
    }
    return true;
  }

  router.navigate(['/super-admin/login'], {
    queryParams: { returnUrl: state.url }
  });
  return false;
};
